export default "__VITE_ASSET__afc55a64__"